import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableComponent from "../../components/reusableComponents/reusableInputComponents";
import { useHistory } from "react-router-dom";
import ReusableCardView from "../../components/reusableComponents/ReusableCardView";
import RichTextEditor from "../../components/reusableComponents/richTextEditior";
import { regexValidator } from "../../_helpers/reusablefunctions/regexValidator";
import ApiService from "../../_services/ApiService";
import useSnackDispatcher from "../../_helpers/reusablefunctions/snackBarComponent";
import { formSnackbar } from "../../_services/_constants/snackbar.constant";
import ReusableMultiComponent from "../../components/reusableComponents/ReusableMultiComponent";
import ReusableCheckboxGroup from "../../components/reusableComponents/reusableCheckboxGroup ";
import { useSelector } from "react-redux";
import { eligibleRequirement, featuredRequirement } from "../../_helpers/reusablefunctions/eligibleRequirement";
import ReusableImageComponent from "../../components/reusableComponents/ReusableImageComponent";
import FirebaseImageStore from "../../_helpers/reusablefunctions/firebaseImageStore";
import { validateImageFile } from "../../_helpers/reusablefunctions/validateImageFile";
import { useParams, useLocation } from "react-router-dom";
import ReusableDateInput from "../../components/reusableComponents/ReusableDateInput";
import { useLiveFieldErrors } from "../../hooks/useLiveFieldErrors";
import { scrollToFirstError } from "../../_helpers/reusablefunctions/scrollToFirstError";
import { hasAnyValue } from "../../_helpers/reusablefunctions/formHasData";
import ConfirmationDialog from "../../components/reusableComponents/conformationDialogBox";

const marginBottom = '20px';

export default function CreateOfferManagement(params) {
    const { successSnack, errorSnack } = useSnackDispatcher();
    const userData = useSelector((state) => state.userData.userData);
    const history = useHistory();
    const location = useLocation()?.state;
    const locationEventDetail = location?.eventData;
    const [Howtoredeem, setHowtoredeem] = useState("");
    const [FAQ, setFAQ] = useState("");
    const [Termsconditions, setTermsconditions] = useState("");
    const [Abouttheoffer, setAbouttheoffer] = useState('');
    const [errors, setErrors] = useState({});
    const [confirmLeaveOpen, setConfirmLeaveOpen] = useState(false);
    const lastValidatedDraft = useRef(null); // null until the first submit attempt
    const [Title, setTitle] = useState('');
    const [OfferURL, setOfferURL] = useState('');
    const [loader, setLoader] = useState(false);
    const [eligibleUser, setEligibleUser] = useState([]);
    const [eligibleUserSelection, setEligibleUserSelection] = useState([]);
    const [eligibleRequirementSelection, setEligibleRequirementSelection] = useState([]);
    const [eligibleFeaturedSelection, setEligibleFeaturedSelection] = useState([]);
    const requirement = eligibleRequirement();
    const featureList = featuredRequirement();
    const [selectedFile, setSelectedFile] = useState(null);
    const [offerImageURL, setOfferImageURL] = useState(null);
    const [ValidTillDate, setValidTillDate] = useState(null);
    const [isDraft, setIsDraft] = useState(null);
    const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;

    const { saveAvatar } = FirebaseImageStore({
        selectedFile,
        functionCall: (downloadURL, draft) => submitOfferDetails({ downloadURL, draft })
    });

    // ---------------- edit offer start ---------------
    const { id } = useParams(); // if present, it's edit mode
    const isEditMode = Boolean(id);

    useEffect(() => {
        if (isEditMode && locationEventDetail) {
            const data = locationEventDetail;
            setTitle(data?.Title || '');
            setOfferImageURL(data?.Featured_Banner_URL || null);
            setAbouttheoffer(data?.Abouttheoffer || '');
            setOfferURL(data?.OfferURL || '');
            setHowtoredeem(data?.Howtoredeem || '');
            setFAQ(data?.FAQ || '');
            setTermsconditions(data?.Termsconditions || '');
            setValidTillDate(data?.ValidTillDate || "");
            if (data?.OfferType?.length) {
                const matchedUsers = eligibleUser.filter((item) =>
                    data.OfferType.some((ot) => ot.id === item.id)
                );
                setEligibleUserSelection(matchedUsers);
            }
            setEligibleRequirementSelection(
                requirement.filter((item) => data[item?.Value])
            );
            setEligibleFeaturedSelection(
                featureList.filter((item) => data[item?.Value])
            );
        }
    }, [id, eligibleUser, isEditMode, locationEventDetail]);

    // ---------------- edit offer end ---------------

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            validateImageFile(file, 382, 185, (errorMsg) => {
                if (errorMsg) {
                    setErrors(prev => ({ ...prev, image: errorMsg }));
                    setSelectedFile(null);
                } else {
                    setSelectedFile(file);
                    setErrors(prev => ({ ...prev, image: null }));
                }
            });
        }
    };

    // ---------------------- 
    useEffect(() => {
        ApiService.get('offers_eligible').then((res) => {
            if (res?.status == 200 || res?.status == 201) {
                setEligibleUser(res?.data?.data)
            }
        }).catch(error => {
            console.log("event:", error)
        })
    }, [])

    const hasFormData = () => hasAnyValue([
        Title, OfferURL, Abouttheoffer, Howtoredeem, FAQ, Termsconditions,
        eligibleUserSelection, eligibleRequirementSelection, eligibleFeaturedSelection,
        ValidTillDate, selectedFile,
    ]);

    function backClickHistory(params) {
        if (hasFormData()) {
            setConfirmLeaveOpen(true);
            return;
        }
        history.push('/offer-management')
    }

    const leaveWithoutSaving = () => {
        setConfirmLeaveOpen(false);
        history.push('/offer-management');
    };

    // --------------- validation handler ----------

    function computeValidation(draft) {
        let errors = {};
        let isValid = true;

        if (Title?.trim() === '') {
            errors.Title = "Offer title is required.";
            isValid = false;
        }
        if (Abouttheoffer?.trim() === '') {
            errors.Abouttheoffer = "Offer description is required.";
            isValid = false;
        }

        if (!OfferURL.trim()) {
            errors.OfferURL = 'Offer URL is required';
        } else if (!urlRegex.test(OfferURL)) {
            errors.OfferURL = 'Enter a valid URL';
        }
        if (!draft) {
            if (!eligibleUserSelection.length) {
                errors.eligibleUserSelection = "Target audience is required.";
                isValid = false;
            }
            if (!eligibleRequirementSelection.length) {
                errors.eligibleRequirementSelection = "Check atleast one.";
                isValid = false;
            }
            if (!Termsconditions) {
                errors.Termsconditions = "Terms & Conditions is required.";
                isValid = false;
            }
            if (!selectedFile && !offerImageURL) {
                errors.image = "Please upload the banner.";
                isValid = false;
            }
        }

        return { errors, isValid };
    }

    function validationInputs(draft) {
        lastValidatedDraft.current = draft;
        const { errors, isValid } = computeValidation(draft);
        setErrors(errors); // Store errors in state
        return isValid;
    }

    // after the first submit attempt, keep each field's error in sync with its value
    useLiveFieldErrors({
        setErrors,
        computeErrors: () =>
            lastValidatedDraft.current === null
                ? null
                : computeValidation(lastValidatedDraft.current).errors,
        managedKeys: [
            'Title', 'Abouttheoffer', 'OfferURL',
            'eligibleUserSelection', 'eligibleRequirementSelection', 'Termsconditions',
        ],
        deps: [
            Title, Abouttheoffer, OfferURL,
            eligibleUserSelection, eligibleRequirementSelection, Termsconditions,
        ],
    });

    // ------------- submit handler ---------

    const handleResponse = (res, draft) => {
        if (res.status === 200 || res.status === 201) {
            setLoader(false);
            successSnack(draft ? formSnackbar?.profileSuccess?.successMessageDraft : formSnackbar?.profileSuccess?.successMessage)

            if (draft) {
                history.push('/offer-management/view-offer-draft');
            } else {
                history.push('/offer-management');
            }
        } else {
            const errorData = res?.data || {};
            Object.entries(errorData).forEach(([field, messages]) => {
                if (Array.isArray(messages)) {
                    messages = messages.join(', ');
                } else if (typeof messages === 'object' && messages !== null) {
                    messages = JSON.stringify(messages);
                }
                errorSnack(`${field}: ${messages}`);
            });
        }
    };

    const handleError = (error) => {
        setLoader(false);
        errorSnack(formSnackbar.errors.errorMsg);
        console.log(error);
    };

    function submitProfile(e, draft) {
        e.preventDefault();
        const isValid = validationInputs(draft);
        if (!isValid) {
            scrollToFirstError();
            return;
        }

        // Proceed if no errors
        if (!selectedFile) {
            submitOfferDetails({ draft });
        } else {
            saveAvatar(draft);
        }
    }

    function submitOfferDetails({ downloadURL, draft }) {
        const eligibleuser = eligibleUserSelection.map(delivey => delivey.id)
        let payload = {
            'Featured_Banner_URL': downloadURL,
            'Title': Title,
            'Abouttheoffer': Abouttheoffer,
            'OfferURL': OfferURL,
            'Howtoredeem': Howtoredeem,
            'FAQ': FAQ,
            'Termsconditions': Termsconditions,
            'OfferType': eligibleuser,
            'ValidTillDate': ValidTillDate,
            ...eligibleRequirementSelection
                .filter(delivey => delivey?.Value)
                .reduce((acc, delivey) => ({ ...acc, [delivey.Value]: true }), {}),
            // ...eligibleFeaturedSelection
            //     .filter(delivey => delivey?.Value)
            //     .reduce((acc, delivey) => ({ ...acc, [delivey.Value]: true }), {}),
            ...featureList.reduce((acc, item) => ({
                ...acc,
                [item.Value]: eligibleFeaturedSelection.some(sel => sel.Value === item.Value)
            }), {}),
            'BrandID': userData?.id,
            'BrandLogoURL': userData?.avatar_url,
            'BrandName': userData?.brand_name,
            'Is_draft': draft,
            'Enable_Brand': true
        }
        console.debug("submitoffer: payload", { payload })

        setIsDraft(draft);
        setLoader(true);
        const request = isEditMode
            ? ApiService.put('offers_updation', payload, {}, id)
            : ApiService.post('offers_creation', payload);

        request
            .then(res => handleResponse(res, draft))
            .catch(handleError)
            .finally(() => setLoader(false));
    }

    const ButtonComponent = () => {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ReusableButton loader={isDraft && loader} disabled={isDraft != null ? !isDraft : false} variant="outlined" classNames={'gn-actionbtn-outline gn-actionbtn-color '}
                    onClick={(e) => submitProfile(e, true)}
                    children="Save Draft" sx={{ color: '#6D788D', marginRight: '10px' }} />
                <ReusableButton loader={!isDraft && loader} disabled={isDraft} classNames={'gn-actionbtn'} variant="contained"
                    onClick={(e) => submitProfile(e, false)}
                    children="Publish offer" sx={{ color: '#6D788D' }} />
            </Box>
        )
    }

    return (
        <Box p={4}>
            <Box display={'flex'} alignItems={{ xs: 'none', sm: 'center', md: 'center' }} justifyContent={'space-between'} sx={{ flexDirection: { xs: 'column', sm: 'row', md: 'row' }, paddingBottom: { xs: '20px', sm: 0, md: 0 } }}>
                <ReusableHeadingComponents bacHistory={true} clickHandlerBack={backClickHistory} heading={'Offer Creation Form'} subHeading={'Effortlessly Create, Manage, and Track Your Gig Opportunities'} />
                {ButtonComponent()}
            </Box>
            <Grid container spacing={2} >
                {/* Left Section */}
                <Grid item xs={12} md={12}>
                    <ReusableCardView title={<>Upload banner <span style={{ color: '#d32f2f' }}>*</span></>} Component={
                        <Box>
                            <ReusableImageComponent
                                selectedFile={selectedFile}
                                handleFileChange={handleImageChange}
                                disabled={false}
                                imageSrc={offerImageURL} // Or provide a URL if editing existing image
                                tooltipTitle="Change Cover Image"
                                imageBannerRatioText='The Offer image must be 382x185 pixels.'
                                error={!!errors.image}
                                helperText={errors.image}
                                selectedOptions={eligibleFeaturedSelection}
                                setSelectedOptions={setEligibleFeaturedSelection}
                            />
                        </Box>
                    } />
                </Grid>
                <Grid item xs={12} md={6}>
                    <ReusableCardView title="Basic" Component={
                        <Box px={3} pt={3}>
                            {/* <Box p={3}> */}
                            <ReusableComponent type="text"
                                label="Offer title"
                                placeholder={'e.g., "Spotify Premium - 50% Off for Students"'}
                                value={Title}
                                onChange={setTitle}
                                error={!!errors.Title}
                                helperText={errors.Title}
                                requireValue={true}
                                marginSize={marginBottom}
                            />
                            {/* <ReusableComponent type="text"
                                label="Offer description"
                                rowsCount={5}
                                multiline={true}
                                value={Abouttheoffer}
                                onChange={setAbouttheoffer}
                                error={!!errors.Abouttheoffer}
                                helperText={errors.Abouttheoffer}
                                requireValue={true}
                                marginSize={marginBottom}
                            /> */}
                            <ReusableComponent
                                type="text"
                                label="Offer url"
                                value={OfferURL}
                                onChange={setOfferURL}
                                error={!!errors.OfferURL}
                                helperText={errors.OfferURL}
                                placeholder="Offer url"
                                requireValue={true}
                                marginSize={marginBottom}
                            />
                            <ReusableDateInput DeadLineDate={ValidTillDate} setDeadLineDate={setValidTillDate} />

                        </Box>
                    } />
                </Grid>

                {/* Right Section */}
                <Grid item xs={12} md={6}>
                    <ReusableCardView title="Eligible Users" Component={
                        <Box px={3} pt={3} pb={1}>
                            {/* <Box p={3}> */}
                            {/* {console.debug("eligibleUser", { eligibleUserSelection })} */}
                            <ReusableMultiComponent label={'Target audience'}
                                options={eligibleUser}
                                selectedOptions={eligibleUserSelection}
                                setSelectedOptions={setEligibleUserSelection}
                                optionLabel="TypeName"
                                requireValue={true}
                                error={!!errors.eligibleUserSelection}
                                helperText={errors.eligibleUserSelection}
                            />
                        </Box>
                    }
                        disablepaddingBottom={true} />

                    <ReusableCardView title={<>Targeting <span style={{ color: '#d32f2f' }}>*</span></>} Component={
                        <Box px={3}>
                            <ReusableCheckboxGroup
                                title=""
                                options={requirement}
                                selectedOptions={eligibleRequirementSelection}
                                setSelectedOptions={setEligibleRequirementSelection}
                                optionLabel="Name"
                                selectAllLabel="All Users"
                                error={!!errors.eligibleRequirementSelection}
                                helperText={errors.eligibleRequirementSelection}
                            />
                        </Box>
                    } disablepaddingBottom={true} />

                    {/* --------------- featured and home featured ------------ */}
                    {/* <ReusableCardView title="Banner Placement" Component={
                        <Box px={3}>
                            <ReusableCheckboxGroup
                                title=""
                                options={featureList}
                                selectedOptions={eligibleFeaturedSelection}
                                setSelectedOptions={setEligibleFeaturedSelection}
                                optionLabel="Name"
                                selectAllLabel="All Users"
                            />
                        </Box>
                    } disablepaddingBottom={true} /> */}
                </Grid>

                {/* ------------- offer description --------- */}
                <Grid item xs={12} md={12}>

                    <ReusableCardView title="Offer Description" Component={
                        <Box px={3} pt={3}>
                            <RichTextEditor
                                value={Abouttheoffer}
                                onChange={setAbouttheoffer}
                                placeholder="Offer description..."
                                error={!!errors.Abouttheoffer}
                                helperText={errors.Abouttheoffer}
                            />
                        </Box>
                    } />
                </Grid>

                {/* --------------------- */}
                <Grid item xs={12} md={12}>

                    <ReusableCardView title=" Redemption Instructions" Component={
                        <Box px={3} pt={3}>

                            {/* <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#4C4E64', fontSize: '14px', marginBottom: 2 }}>
                                Redemption Instructions
                            </Typography> */}
                            <RichTextEditor
                                value={Howtoredeem}
                                onChange={setHowtoredeem}
                                placeholder="Write something..."

                            />


                        </Box>
                    } />
                </Grid>
                {/* ----------------------- Term&Condition ---------------- */}
                <Grid item xs={12} md={12}>
                    <ReusableCardView title={<>Terms & Conditions <span style={{ color: '#d32f2f' }}>*</span></>} Component={
                        <Box px={3} pt={3}>
                            {/* <Box p={3}> */}
                            <RichTextEditor
                                value={Termsconditions}
                                onChange={setTermsconditions}
                                placeholder="Write something..."
                                error={!!errors.Termsconditions}
                                helperText={errors.Termsconditions}
                            />
                        </Box>
                    } />
                </Grid>
                {/* ----------------- FAQS ------------------ */}
                <Grid item xs={12} md={12}>
                    <ReusableCardView title="FAQ" Component={
                        <Box px={3} pt={3}>
                            {/* <Box p={3}> */}
                            <RichTextEditor
                                value={FAQ}
                                onChange={setFAQ}
                                placeholder="Write something..."
                            />
                        </Box>
                    } />
                </Grid>
            </Grid>
            <Box sx={{ marginBottom: '30px' }}>{ButtonComponent()}</Box>

            <ConfirmationDialog
                open={confirmLeaveOpen}
                title="Leave without saving?"
                message="You have unsaved details in this offer. If you leave now, they will be lost."
                onClose={() => setConfirmLeaveOpen(false)}
                onConfirm={leaveWithoutSaving}
            />
        </Box>
    )
}
